/**
 * Quote numbers pasted into the Enrol Quotes box: split on new lines, commas and
 * spaces (or tabs, as pasted from Excel), trimmed, blanks dropped, and each number
 * kept once in the order first seen. The backend matches the number as typed.
 */
export function splitQuoteNumbers(text) {
  var seen = {}
  var out = []
  String(text || '').split(/[\s,;]+/).forEach(function (raw) {
    var n = raw.trim()
    if (n && !seen[n]) {
      seen[n] = true
      out.push(n)
    }
  })
  return out
}
